/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type AlertActionExecution = typeof AlertActionExecution[keyof typeof AlertActionExecution];


export const AlertActionExecution = {
  Backend: 'Backend',
  Client: 'Client',
  Hybrid: 'Hybrid',
} as const;
